module.exports = __webpack_public_path__ + "static/media/grow-drag-add-icon.cb6d166a.svg";